import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-box',
  templateUrl: './skeleton-box.component.html',
  styleUrls: ['./skeleton-box.component.scss']
})
export class SkeletonBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
